"use client";
import { v4 as uuidv4 } from "uuid";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import type { HomepageOptimizationV3TestResult } from "@/monarch/rules/homepageOptimizationV3/types";
import BaseHomepageHeroSpotlight from "./BaseHomepageHeroSpotlight";
import BaseHomepageHeroMarketplace from "../HomepageHeroMarketplace/BaseHomepageHeroMarketplace";

export default function HomepageHeroSpotlight() {
  return (
    <MonarchDataConsumer<HomepageOptimizationV3TestResult>
      experimentKey="useHomepageOptimizationV3"
      render={(testResult) => {
        const { data } = testResult;

        if (!data?.sections) {
          return <BaseHomepageHeroMarketplace />;
        }

        const section = data.sections[0];

        if (!section) {
          return <BaseHomepageHeroMarketplace />;
        }

        const primaryCta =
          section.primaryCtaLink && section.primaryCtaText
            ? {
                url: section.primaryCtaLink,
                label: section.primaryCtaText,
              }
            : undefined;
        const secondaryCta =
          section.secondaryCtaLink && section.secondaryCtaText
            ? {
                url: section.secondaryCtaLink,
                label: section.secondaryCtaText,
              }
            : undefined;

        // Filter products by creation date if newTimeWindowDays is provided
        let filteredProducts = section.products ?? [];
        if (section.newTimeWindowDays) {
          const newTimeWindowDays = section.newTimeWindowDays;
          const cutoffDate = new Date();
          cutoffDate.setDate(cutoffDate.getDate() - newTimeWindowDays);
          const cutoffTimestamp = Math.floor(cutoffDate.getTime() / 1000);

          filteredProducts = filteredProducts.filter((product) => {
            const productCreated = (product as any).productCreated;
            if (!productCreated) return true;
            return productCreated >= cutoffTimestamp;
          });
        }

        return (
          <BaseHomepageHeroSpotlight
            {...section}
            variant={section.variant}
            key={uuidv4()}
            primaryCta={primaryCta}
            secondaryCta={secondaryCta}
            desktopImage={section.imageUrlDesktop}
            tabletImage={section.imageUrlTablet}
            mobileImage={section.imageUrlMobile}
            titleColor={section.titleTextColor}
            descriptionColor={section.descriptionTextColor}
            products={filteredProducts}
          />
        );
      }}
    />
  );
}
